import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from 'styled-components';
// template components
import AssistiveText from '@nmx/template/dist/componentLibrary/components/AssistiveText';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// images
import ImageWebp from './images/ava-digital-badge.webp';
import ImageMobileWebp from './images/ava-digital-badge-mobile.webp';
// styles
import {
  ColStyled,
  PictureStyled,
} from './styles';

const getBadgePicture = () => {
  return (
    <PictureStyled
      id='ava-digital-badge-image'
      src={ImageWebp}
      mobileSrc={ImageMobileWebp}
      altText='2025 Audio&#45;Visual Arts (AVA) Digital Awards Gold Winner.'
      lazyLoad={false}
    />
  );
};

export default () => {
  const theme = useContext(ThemeContext);
  const mediumDown = theme.mediumDown();
  const [isMobile, setIsMobile] = useState(mediumDown);

  useEffect(() => {
    if (mediumDown !== isMobile) {
      setIsMobile(mediumDown);
    }
  }, [mediumDown, isMobile]);

  return (
    <SectionContainer
      disableBottomPadding
      id='podcast-intro'>
      <AssistiveText
        component='h2'
        disableBottomPadding>
        About the Better Way to Money&#174; podcast
      </AssistiveText>
      <Row align='center'>
        <ColStyled
          medium={6}
          large={7}>
          <Typography nextElement={mediumDown ? 'graphic' : 'typography'}>
            We want you to feel better about your money. In each episode, experts will share how real people, like you, are successfully approaching their finances. From job changes to raising financially&#45;savvy kids to setting yourself up to retire, we&#39;ll have a deeper conversation about it.
          </Typography>
          {isMobile && getBadgePicture()}
        </ColStyled>
        {!isMobile
          && <ColStyled
            medium={6}
            large={4}>
            {getBadgePicture()}
          </ColStyled>}
      </Row>
    </SectionContainer>
  );
};
